import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import Component from './audio-component-editor.vue'

export default Node.create({
  name: 'audio',

  group: 'block',

  atom: true,

  addAttributes() {
    return {
      file: {
        default: "",
        rendered: true
      },
      color: {
        default: "accent",
        rendered: true
      },
      pathAudio: {
        default: null,
        rendered: true
      },
      type: {
        default: "block1",
        rendered: true
      },
      title: {
        default: "",
        rendered: true
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'audio-component',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['audio-component', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return VueNodeViewRenderer(Component)
  },
})